import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalePath } from "../hooks/useLocalePath";
import { Separator } from "./ui/separator";
import { Compass } from "lucide-react";

export function SiteFooter() {
  const { t } = useTranslation();
  const lp = useLocalePath();

  return (
    <footer className="py-10 bg-slate-900 text-slate-400" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Compass className="h-5 w-5 text-teal-400" />
              <span className="font-heading font-semibold text-white">ImmigrationGuide</span>
            </div>
            <p className="text-xs max-w-xs">{t("footer.tagline")}</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-12 gap-y-4 text-sm">
            <div className="space-y-2">
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{t("footer.product")}</p>
              <Link to={lp("/guides")} className="block hover:text-white transition-colors">{t("nav.guides")}</Link>
              <Link to={lp("/gc")} className="block hover:text-white transition-colors">{t("footer.greenCard")}</Link>
              <Link to={lp("/green-card-lottery")} className="block hover:text-white transition-colors">{t("footer.dvLottery")}</Link>
              <Link to={lp("/dmv-guide")} className="block hover:text-white transition-colors">{t("nav.dmvGuide")}</Link>
              <Link to={lp("/pricing")} className="block hover:text-white transition-colors">{t("nav.pricing")}</Link>
            </div>
            <div className="space-y-2">
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{t("footer.tools")}</p>
              <Link to={lp("/gc/green-card-timeline")} className="block hover:text-white transition-colors">{t("footer.timelineCalc")}</Link>
              <Link to={lp("/gc/documents-checklist")} className="block hover:text-white transition-colors">Documents Checklist</Link>
              <Link to={lp("/auth")} className="block hover:text-white transition-colors">{t("nav.signIn")}</Link>
            </div>
            <div className="space-y-2">
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{t("footer.legal")}</p>
              <Link to={lp("/privacy")} className="block hover:text-white transition-colors">{t("footer.privacy")}</Link>
              <Link to={lp("/terms")} className="block hover:text-white transition-colors">{t("footer.terms")}</Link>
              <Link to={lp("/contact")} className="block hover:text-white transition-colors">{t("footer.contact")}</Link>
            </div>
          </div>
        </div>
        <Separator className="my-6 bg-slate-800" />
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-slate-500">{t("footer.disclaimer")}</p>
          <p className="text-xs text-slate-600 flex-shrink-0">
            &copy; {new Date().getFullYear()} ImmigrationGuide
          </p>
        </div>
      </div>
    </footer>
  );
}
